export { AlfaIdBannerContent } from './alfaid-banner-content';
export type { AlfaIdBannerContentProps } from './alfaid-banner-content';
